import { useTranslation } from "react-i18next";
import HistorySectionLayout from "../../components/History/HistorySectionLayout";
import OrderHistoryTable from "../../components/History/OrderHistoryTable";
import { useOrderHistory } from "../../hooks/api/history/useOrderHistory";
import { useUrlInstrumentFilter } from "../../hooks/useUrlParamState";
import { AssetResponse } from "../../utils/asset";

interface IOrderHistoryTabProps {
  mode?: "portfolio" | "trading";
  hideTitle?: boolean;
  hideFilter?: boolean;
  /**
   * Server-side market scope for the "show selected market only" toggle. When
   * set, pins the query to the current market's asset (mirrors Positions/Open
   * Orders). Asset only — no instrument-type constraint, so spot + perp for the
   * asset are both included.
   */
  assetFilter?: AssetResponse;
}

export function OrderHistoryTab({
  mode = "portfolio",
  hideTitle,
  hideFilter,
  assetFilter,
}: IOrderHistoryTabProps = {}) {
  const { t } = useTranslation("app", {
    keyPrefix: "pages.OrderHistoryTab",
  });
  const [filter, setFilter] = useUrlInstrumentFilter(
    "tab",
    mode === "portfolio"
  );
  const data = useOrderHistory({
    instrumentType: filter,
    asset: assetFilter,
  });

  return (
    <HistorySectionLayout
      title={t("order_history", { defaultValue: "Order History" })}
      mode={mode}
      hideTitle={hideTitle}
      filter={filter}
      onSetFilter={hideFilter ? undefined : setFilter}
    >
      {(tableHeight) => (
        <OrderHistoryTable
          items={data.items}
          isLoading={data.isLoading}
          isLoadingMore={data.isLoadingMore}
          hasMore={data.hasMore}
          onLoadMore={data.loadMore}
          height={tableHeight}
        />
      )}
    </HistorySectionLayout>
  );
}
